export default "__VITE_ASSET__DUaHNvLa__"